import { render } from "./CreateService.vue?vue&type=template&id=4b1831a4&scoped=true"
import script from "./CreateService.vue?vue&type=script&lang=js"
export * from "./CreateService.vue?vue&type=script&lang=js"

import "./CreateService.vue?vue&type=style&index=0&id=4b1831a4&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1831a4"]])

export default __exports__